import React from "react";
import { Link } from "react-router-dom";
import bgone from "../../../assets/images/background/bg-16.png";
import bgtwo from "../../../assets/images/background/bg-17.png";
import bgthree from "../../../assets/images/background/bg-18.png";
import menuone from "../../../assets/images/resource/mango-tango-salad.png";
import menutwo from "../../../assets/images/resource/menus-2.jpg";
import menufive from "../../../assets/images/resource/menus-5.png";

function LunchItems() {
    return (
        <>
            <section className="menu-one">
                <div className="right-bg">
                    <img src={bgone} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>ALWAYS FRESH</span>
                        </div>
                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Soup &amp; Salad &amp; Bowls</h2>
                    </div>

                    <div className="row clearfix">
                        <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image">
                                    <img src={menuone} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        François&apos;s Cream of
                                                        Wild Mushroom
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Soup of the day
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">Chef Salad</Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Grilled chicken, ham, cheese,
                                                egg, potatoes &amp; tomatoes,
                                                served on a bed of mixed greens
                                                served with a fine herb
                                                vinaigrette.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        House Caesar Salad
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                François&apos; homemade Caesar
                                                dressing, garlic croutons &amp;
                                                parmesan cheese. (Add Chicken
                                                Breast)
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Mango Tango Bowl
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Mango, fresh strawberries,
                                                beets, black beans, edamame,
                                                cabbage, fresh cilantro, roasted
                                                almonds, zesty lime dressing.
                                                (Add on Smoked tofu | Seasoned
                                                grilled chicken | Smoked Salmon |
                                                Baby shrimp)
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one">
                <div className="right-bg">
                    <img src={bgone} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle">
                            <span>ALWAYS FRESH</span>
                        </div>
                        <div className="pattern-image">
                            <img
                                src={
                                    require("../../../assets/images/icons/separator.svg")
                                        .default
                                }
                                alt="mySvgImage"
                            />
                        </div>

                        <h2>Sandwiches &amp; Poutines</h2>
                        <div className="text lunch-menu-note">
                            Served with coleslaw and your choice of side: Fries
                            or garden salad.
                            <br />
                            <br />
                            Side upgrades: Soup of the moment, Cream of mushroom
                            soup, Poutine, Caesar salad.
                        </div>
                    </div>

                    <div className="row clearfix">
                        <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image">
                                    <img src={menufive} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Bison Burger
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Cheddar cheese, caramelized
                                                onions, tomatoes, lettuce,
                                                pickles, with a roasted pepper
                                                aioli. Served on a brioche bun.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        François&apos;s Spicy Lamb
                                                        Burger
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Signature plate. Homemade lamb
                                                patty, caramelized onions,
                                                tomatoes, lettuce, Swiss
                                                cheese, &amp; mayonnaise. Served
                                                on a brioche bun.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Montreal Reuben Sandwich
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Montreal smoked meat, sauerkraut
                                                &amp; Swiss cheese. Served on
                                                toasted rye bread.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Clubhouse Croissant
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Grilled chicken breast, bacon,
                                                tomatoes, lettuce, &amp;
                                                mayonnaise. Served on a
                                                croissant baked in house.
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                <div className="left-bg">
                    <img src={bgtwo} alt="" title="" />
                </div>
                <div className="right-bg-2">
                    <img src={bgthree} alt="" title="" />
                </div>
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image">
                                    <img src={menutwo} alt="" />
                                </div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-12 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Steak &amp; Frites
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Grass fed 6oz AAA sirloin,
                                                sautéed mushrooms, &amp;
                                                caramelized onions, with Foyot
                                                sauce.
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        Classic Poutine
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Hand cut fries, Quebec cheese
                                                curds, &amp; François&apos;
                                                gravy. (Add Smoked Meat | Add
                                                Chicken | Add Duck Confit)
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix">
                                            <div className="ttl clearfix">
                                                <h5>
                                                    <Link to="#">
                                                        French Fries &amp; Aioli
                                                    </Link>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="text desc">
                                            <Link to="#">
                                                Bowl of hand cut French fries
                                                with roasted peppers aioli.
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="lower-link-box text-center">
                    <Link
                        to="https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu"
                        className="theme-btn btn-style-two clearfix"
                    >
                        <span className="btn-wrap">
                            <span className="text-one">view all menu</span>
                            <span className="text-two">view all menu</span>
                        </span>
                    </Link>
                </div>
            </section>
        </>
    );
}

export default LunchItems;
